var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfSelect',_vm._b({staticClass:"pf-select",style:({
    '--select-dropdown-border-width': '1px',
    '--select-label-font-size': '16px',
    '--select-label-top': '0',
  }),on:{"input":_vm.changeHandler}},'SfSelect',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }